import Vue from "vue";
import Vuex from "vuex";
import search from "./modules/search";
import overlay from "./modules/overlay";

Vue.use( Vuex );

const debug = process.env.NODE_ENV !== "production";

const modules = {
  search,
  overlay
};

export default new Vuex.Store( {
  strict: debug,
  modules
} );
